import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import NewTestPackage from "src/components/TestPackage/new";
import { RESOURCE_TYPE, ROLES } from "src/constant/common";

const NewTestPackagePage = () => {
  return <NewTestPackage />;
};

export default routeGuard(NewTestPackagePage, RESOURCE_TYPE.PROJECT_INSTANCE, ROLES.ADMIN || ROLES.SERVICE_ADMIN || ROLES.EDITOR);
